import {
  Component,
  Input,
  SimpleChanges,
  EventEmitter,
  Output,
  Pipe,
  PipeTransform,
  OnChanges,
} from '@angular/core';
import { CHECKED_STATUS, SearchService } from '../../../services/search/search.service';
import { StorageService } from '../../../services/storage/storage.service';
import { TargetGroups, SearchTarget } from '../../../core/interfaces/search.interface';

@Pipe({ name: 'addStyleToHtml' })
export class AddStyleToHtmlPipe implements PipeTransform {
  transform(value: string) {
    if (value.includes('<h3>')) {
      value = value.replace('<h3>', "<h3 style='display:inline-block !imponrtant'>");
    }
    if (value.includes('<H3>')) {
      value = value.replace('<H3>', "<h3 style='display:inline-block !important'>");
    }
    return value;
  }
}

@Component({
  selector: 'advanced-resources',
  templateUrl: './advanced-resources.component.html',
  styleUrls: ['./advanced-resources.component.scss'],
})
export class AdvancedResourcesComponent implements OnChanges {
  @Input() embeddedComponent = false;
  @Input() resourcesAS: TargetGroups[] = [];
  @Output() fetchResEE = new EventEmitter<number[]>();

  PARTIAL_CHECKED = CHECKED_STATUS.PARTIAL;
  showCollapseAll: boolean;

  constructor(
    private _searchService: SearchService,
    private _storageService: StorageService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.resourcesAS?.currentValue) {
      this.showCollapseAll = !changes.resourcesAS.currentValue.some((r) => r.isCollapse);
    }
  }

  openUrl(url = ''): void {
    if (url?.includes('useracct.asp?') || url?.includes('MyStatus.aspx')) {
      url = this._includeSessId(url);
      this.openLink(url);
    } else {
      this.openLink(url);
    }
  }

  private _includeSessId(url = ''): string {
    if (url?.includes('myses=&')) {
      const userdata = this._storageService.getItem('userData');
      const sessionId = userdata?.sessionId;
      if (sessionId) {
        url = url.replace('myses=&', `myses=${sessionId}&`);
      }
    }
    return url;
  }

  openLink(url) {
    if (url) {
      window.open(url, '_blank', 'location=yes,height=650,width=650,scrollbars=yes,status=yes');
    }
  }

  resetAll() {
    this.resourcesAS = this._searchService.getSearchResources();
    this._emitResourceSelection();
  }

  checkGroup(event, targets) {
    targets.forEach((t) => (t.isDefault = event.target.checked));
    SearchService.setCheckStatus(this.resourcesAS);
    this._emitResourceSelection();
  }

  checkResource(event, resource: SearchTarget): void {
    resource.isDefault = event.target.checked;
    SearchService.toggleResourcesByLibraryDBPoolKey(this.resourcesAS, resource);
    this._emitResourceSelection();
  }

  checkAll(checked: boolean) {
    this.resourcesAS.forEach((r) => r.searchTargets.forEach((s) => (s.isDefault = checked)));
    SearchService.setCheckStatus(this.resourcesAS);
    this._emitResourceSelection();
  }

  toggleGroup(item: TargetGroups) {
    item.isCollapse = !item.isCollapse;

    if (item.isCollapse) {
      const allCollapse = !this.resourcesAS.some((r) => !r.isCollapse);
      if (allCollapse) {
        this.showCollapseAll = false;
      }
    } else {
      const allExpanded = !this.resourcesAS.some((r) => r.isCollapse);
      if (allExpanded) {
        this.showCollapseAll = true;
      }
    }
  }

  toggleExpandCollapse() {
    this.resourcesAS.map((r) => (r.isCollapse = this.showCollapseAll));
    this.showCollapseAll = !this.showCollapseAll;
  }

  private _emitResourceSelection() {
    const selectResources = SearchService.getSelectResources(this.resourcesAS);
    this.fetchResEE.emit(selectResources);
  }
}
